import React from 'react';
import { IconSvgProps } from '@models/common';

const LockKeyholeOpen: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M13.3333 7.5V5.83333C13.3333 3.99238 11.8409 2.5 9.99999 2.5C8.94733 2.5 8.00864 2.98795 7.39775 3.75M6.83332 17.5H13.1667C14.1001 17.5 14.5668 17.5 14.9233 17.3183C15.2369 17.1586 15.4919 16.9036 15.6517 16.59C15.8333 16.2335 15.8333 15.7668 15.8333 14.8333V10.1667C15.8333 9.23325 15.8333 8.76654 15.6517 8.41002C15.4919 8.09641 15.2369 7.84144 14.9233 7.68166C14.5668 7.5 14.1001 7.5 13.1667 7.5H6.83332C5.8999 7.5 5.43319 7.5 5.07667 7.68166C4.76307 7.84144 4.5081 8.09641 4.34831 8.41002C4.16666 8.76654 4.16666 9.23325 4.16666 10.1667V14.8333C4.16666 15.7668 4.16666 16.2335 4.34831 16.59C4.5081 16.9036 4.76307 17.1586 5.07667 17.3183C5.43319 17.5 5.8999 17.5 6.83332 17.5Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <circle
        cx='9.99999'
        cy='12.5'
        r='1.125'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.583333'
      />
    </svg>
  );
};

export default LockKeyholeOpen;
